module.exports = __webpack_public_path__ + "static/img/me_bg@2x.5b9ccff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/me_bg@2x.png
// module id = 4MSL
// module chunks = 1